"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _projectType = require("@/api/project/projectType");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          matchTypeName: [{
            required: true,
            message: "请输入项目类型名称",
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "项目类型名称",
          isDisabled: false,
          placeholder: "请输入项目类型名称",
          prop: "matchTypeName",
          value: "",
          required: true,
          span: 12
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      (0, _projectType.projectTypeEdit)({
        id: this.$route.query.id,
        matchTypeName: e.matchTypeName
      }).then(function (res) {
        _this.$message.success("操作成功。");
        _this.$router.push("/object/objectType");
      });
    }
  },
  created: function created() {
    this.formData.formItem[0].value = this.$route.query.matchTypeName;
  }
};